var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66133 5.50902L6.99467 7.53423L6.50333 7.08675L8.99467 4.0734L11.4967 7.10394L10.9947 7.54348L9.328 5.51034V10.6831H8.66133V5.50902ZM13.3333 12.005H4.66667C3.01267 12.005 1.66667 10.6712 1.66667 9.03066C1.66667 7.59107 2.70333 6.36167 4.132 6.10654L4.65133 6.014L4.68 5.4925C4.80333 3.21348 6.70067 1.42952 9 1.42952C11.2993 1.42952 13.1967 3.21348 13.3187 5.4925L13.348 6.014L13.868 6.10654C15.296 6.36167 16.3333 7.59107 16.3333 9.03066C16.3333 10.6712 14.9873 12.005 13.3333 12.005ZM13.9853 5.45614C13.844 2.84466 11.6707 0.768555 9 0.768555C6.32933 0.768555 4.15533 2.84466 4.014 5.45614C2.30067 5.76217 1 7.24473 1 9.03066C1 11.038 2.642 12.666 4.66667 12.666H13.3333C15.358 12.666 17 11.038 17 9.03066C17 7.24473 15.6993 5.76217 13.9853 5.45614Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.a833189fc9df06be4cba75ca3c116805.svg";
export { ForwardRef as ReactComponent };